<template>
  <div
    class="local-lm--orders-tag"
    v-html="template"
  />
</template>

<script>
import LogoVolums from '@/assets/img/volums.svg'
import LogoPallets from '@/assets/img/pallets.svg'
import LogoequivalentPallets from '@/assets/img/equivalentPallets.svg'

export default {
  name: 'VolumesTag',
  props: {
    volumes: Number,
    pallets: Number,
    equivalents: Number,
    normalPalletEquivalent: Number
  },
  computed: {
    template () {
      const tagHTML = (data, svg) => `<img src="${svg}" /> x ${data}`
      const showVolumes = this.volumes ? tagHTML(this.volumes, LogoVolums) : ''
      const showPallets = this.pallets ? tagHTML(this.pallets, LogoPallets) : ''
      const showEquivalents = this.equivalents ? tagHTML(this.equivalents, LogoequivalentPallets) : ''
      const showNormalPalletEquivalent = this.normalPalletEquivalent ? `= P ${this.normalPalletEquivalent}` : ''

      return `${showVolumes} ${showPallets} ${showEquivalents} ${showNormalPalletEquivalent}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VolumesTag.vue